










import { Vue, Component } from 'vue-property-decorator';
import BajasCobranza from './BajasCobranza.vue';

@Component({ components: { BajasCobranza } })
export default class BajasCobranzaPatanlla extends Vue {}
